// extracted by mini-css-extract-plugin
export var formContainer = "_l0-0";
export var message = "_l0-1";